import { render, staticRenderFns } from "./healthDetail.vue?vue&type=template&id=6023e0b6&scoped=true&"
import script from "./healthDetail.vue?vue&type=script&lang=js&"
export * from "./healthDetail.vue?vue&type=script&lang=js&"
import style0 from "./healthDetail.vue?vue&type=style&index=0&id=6023e0b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6023e0b6",
  null
  
)

export default component.exports